var request = require("request");

const state = {
  token: null
};

const getters = {
  token: state => state.token,
  hasToken: state => {
    return !!state.token;
  }
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  }
};

const actions = {
  getToken: ({ commit }, params) => {
    var options = {
      method: "POST",
      url: params.url,
      headers: {
        Authorization:
          "Basic " + btoa(params.clientid + ":" + params.clientsecret),
        "Content-Type": "application/x-www-form-urlencoded"
      },
      form: {
        grant_type: "client_credentials",
        scope: "planning/execute"
      }
    };
    request(options, function(error, response, body) {
      if (error) {
        commit("setToken", null);
      } else {
        commit("setToken", JSON.parse(body).access_token);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
